import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";
import { z } from "zod";
export const OpacityValue = z.object({
    unit: DimensionUnit,
    measure: z.number(),
});
export const OpacityTokenData = tokenAliasOrValue(OpacityValue);
